<template>
  <aside>
    <div
      class="relative border px-6 py-4 text-sm bg-white"
      :class="status.class"
    >
      <div class="mb-4 flex justify-between">
        <h1 class="text-lg">
          Claim for {{ item.claim_period | formatDateMMYY }}
        </h1>
        <app-badge
          :icon="status.icon"
          :type="status.type"
        >
          {{ status.text }}
        </app-badge>
      </div>
      <template v-if="item.rejected_at">
        <p class="italic">
          {{ item.rejected_reason }}
        </p>
      </template>
      <table class="w-full my-4">
        <tbody>
          <tr
            v-for="(requestKey, index) in requestKeys"
            :key="index"
          >
            <th
              class="py-1 pr-4"
              :class="{
                'border-b': index + 1 !== requestKeys.length
              }"
            >
              {{ requestKey | sentencecase }}
            </th>
            <td
              class="py-1"
              :class="{
                'border-b': index + 1 !== requestKeys.length
              }"
            >
              {{ request[requestKey] | toPounds }}
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <th class="py-1 border-t-2 text-right pr-4">
              Total
            </th>
            <td class="py-1 border-t-2">
              {{ claimTotal | toPounds }}
            </td>
          </tr>
          <tr class="text-base">
            <th class="py-1 border-t-2 text-right pr-4">
              Claim Value
            </th>
            <td class="py-1 border-t-2">
              {{ claimValue | toPounds }}
            </td>
          </tr>
        </tfoot>
      </table>
      <p class="text-right">
        <icon-link
          v-if="item.invoice_file_id"
          :href="
            route('applications.files.download', {
              application: projectUuid,
              file: item.invoice_file_id,
              project: true
            })
          "
          icon="cheveron-down-circle"
          icon-placement="right"
          download
        >
          Download Financial Information
        </icon-link>
      </p>
    </div>
    <p class="text-xs italic text-grey-600 mx-6 mt-2">
      <b>{{ item.created_at | formatDate }}</b>
    </p>
  </aside>
</template>

<script>
import { parseISO, format } from "date-fns";
export default {
  name: "ClaimItem",
  filters: {
    formatDateMMYY(value) {
      return value.substring(0, 2) + "/" + value.substring(2, 4);
    },
    formatDate(value) {
      return format(parseISO(value), "Lo LLLL yyyy");
    },
    toPounds(value) {
      if (isNaN(value)) return "----";
      return parseFloat(value).toLocaleString("en-GB", {
        style: "currency",
        currency: "GBP"
      });
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    projectUuid: {
      type: String,
      required: true
    }
  },
  computed: {
    parsedRequest() {
      return JSON.parse(this.item.request);
    },
    request() {
      const request = { ...this.parsedRequest };
      delete request.total;
      delete request.value;
      return request;
    },
    requestKeys() {
      return Object.keys(this.request);
    },
    claimTotal() {
      return this.parsedRequest.total;
    },
    claimValue() {
      return this.parsedRequest.value;
    },
    status() {
      const status = {};
      if(this.claimTotal === "0.00") {
        status.text = "Zero Claim";
        status.icon = "check";
        status.type = "positive";
        status.class = "border-positive-500";
      } else if (
        !this.item.approved_at &&
        !this.item.rejected_at &&
        !this.item.paid_at
      ) {
        status.text = "Pending";
        status.icon = "time";
        status.type = "neutral";
        status.class = "border-neutral-500";
      } else if (this.item.approved_at && !this.item.paid_at) {
        status.text = "Awaiting Payment";
        status.icon = "time";
        status.class = "border-primary-500";
      } else if (this.item.rejected_at) {
        status.text = "Rejected";
        status.icon = "close-circle";
        status.type = "negative";
        status.class = "border-negative-500";
      } else {
        status.text = "Claim Paid";
        status.icon = "check";
        status.type = "positive";
        status.class = "border-positive-500";
      }
      return status;
    }
  }
};
</script>
